import React from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/membershipUnitsSagas";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import TotalMembers from "./smartComponents/TotalMembers";
import NetUnits from "./smartComponents/NetUnits";
import FrozenMembers from "./smartComponents/FrozenMembers";
import MonthlyAttritionRate from "./smartComponents/MonthlyAttritionRate";
import ScheduledCancellations from "./smartComponents/ScheduledCancellations";
import TotalNewMembers from "./smartComponents/TotalNewMembers";
import CancelledMembers from "./smartComponents/CancelledMembers";
import NewMembers from "./smartComponents/NewMembers";
import ReactivatedMembers from "./smartComponents/ReactivatedMembers";
import { PreviousToggle } from "./smartComponents/PreviousToggle";
import TotalPastDues from "./smartComponents/TotalPastDues";
import { useFetchData } from "../hooks/dataFetchingHooks";
import MembershipDetailsChart from "./smartComponents/MembershipDetailsChart";
import RiskMembers from "./smartComponents/AtRiskMembers";
import RollingThirtyAttritionRate from "./smartComponents/RollingThirtyAttritionRate";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const MembershipUnitsModule = (props) => {
  useFetchData({
    moduleName: "membershipUnits",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });
  const { qa } = useSelector((state) => state.commonReducer.commonProps);
  const isLoading = useSelector((state) => state.membershipUnits.isLoading);
  const displayTotalNewMembers = useSelector(
    (state) => state.membershipUnits.membershipUnits.totalNewMembers.displayTotalNewMembers
  );

  return (
    <SectionToggle
      title="Membership Units"
      learnMore={
        <KBLearnMore
          title="Membership Units"
          description="This report shows key membership activity metrics—including active, new, frozen, rejoin, cancelled, at-risk, and past-due members—alongside trends in net units and scheduled cancellations. These insights help you understand overall membership health, identify risk patterns, and evaluate how monthly changes impact growth and retention."
          kbUrl={ILEARN_URLS.dashboard.membershipUnits}
        />
      }
      customClass={`membershipunitsWidget ${isLoading ? "" : "active"}`}
      height={780}
      isLoading={isLoading}
      content={
        <>
          <PreviousToggle />
          <div className="content">
            <TotalMembers qa={qa} />
            <FrozenMembers qa={qa} />
            {displayTotalNewMembers ? (
              <>
                <TotalNewMembers qa={qa} />
                <CancelledMembers qa={qa} />
                <NewMembers qa={qa} />
                <ReactivatedMembers qa={qa} />
              </>
            ) : null}

            <RiskMembers qa={qa} />

            <NetUnits qa={qa} />

            <MonthlyAttritionRate qa={qa} />

            <RollingThirtyAttritionRate qa={qa} />

            <ScheduledCancellations qa={qa} />

            <TotalPastDues qa={qa} />

            <MembershipDetailsChart />
          </div>
        </>
      }
    />
  );
};

export default MembershipUnitsModule;
